<template>
  <div class="fullscreen-loader">
    <img src="@/assets/img/przedruk_loader2.gif" alt />
  </div>
</template>

<script>
export default {
  name: "FullScreenLoader"
};
</script>

<style lang="scss" scoped>
.fullscreen-loader {
  position: fixed;
  background-color: $primary-color;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;

  img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  &.hidden {
    animation: fadeOutHide 1s ease both;
  }
}
</style>